import styled from 'styled-components';
import { fadeIn, fadeOut } from '../../../../utilities/animations';
import {
  whiteSphera,
  brandBlack,
  neutralBlueGray,
  grayMediumSphera,
  greenSp,
  grayLight,
  blueSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalAdviceValidation ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${(props) => (props.showModalAdviceValidation ? fadeIn : fadeOut)} 0.5s linear;
  transition: all 0.5s;
  > div {
    width: 70%;
    background-color: ${whiteSphera};
    border-radius: 5px;
    padding-top: 1%;
    padding-bottom: 1%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    > div {
      width: 90%;
    }
  }
`;

export const SectionInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  > h1 {
    color: ${neutralBlueGray};
    font-size: 2.3vw;
  }
  > figure {
    width: 25px;
    height: 25px;
    margin-left: 90%;
    cursor: pointer;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  > div {
    margin: 2%;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    > input {
      border-radius: 5px;
      border: 1px solid ${grayLight};
      font-weight: bold;
      font-size: 1.8vw;
      color: ${neutralBlueGray};
      width: 60%;
      margin: 1% 20%;
      height: 35px;
      text-align: center;
      letter-spacing: 2vw;
    }
    > button {
      margin: 0 5%;
    }
  }

  @media (max-width: 600px) {
    > h1 {
      font-size: 3vw;
    }
    > div {
      margin: 2%;
      > input {
        font-size: 2.8vw;
        width: 80%;
        margin: 1% 5%;
        height: 35px;
        text-align: center;
        letter-spacing: 2vw;
      }
      > button {
        margin: 0 5%;
      }
    }
    > figure {
      width: 25px;
      height: 25px;
      margin-left: 86%;
      cursor: pointer;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export const GeneralDetail = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 2%;
  width: 90%;
  margin-top: 2%;
  > h2 {
    width: 100%;
    font-size: 1.8vw;
    color: ${greenSp};
    margin-bottom: 3%;
  }
  > div {
    width: 45%;
    > h3 {
      color: ${grayMediumSphera};
      border-bottom: 1px solid ${grayMediumSphera};
      font-size: 1.4vw;
    }
    > p {
      color: ${neutralBlueGray};
      font-size: 1.4vw;
    }
    > div {
      > p {
        color: ${neutralBlueGray};
        font-size: 1.4vw;
      }
      > h4 {
        font-size: 1.2vw;
      }
    }
  }

  @media (max-width: 600px) {
    > h2 {
      font-size: 4vw;
    }
    > div {
      width: 45%;
      > h3 {
        font-size: 2.8vw;
      }
      > p {
        font-size: 2.8vw;
      }
    }
  }
`;

export const DetailData = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 2%;
  width: 90%;
  margin: 2% 0;
  > h2 {
    width: 100%;
    font-size: 1.8vw;
    margin: 3% 0;
    color: ${greenSp};
  }
  > div {
    width: 100%;
    display: flex;
    border-bottom: 1px solid ${grayMediumSphera};
    justify-content: space-between;
    margin: 1% 0;
    > h3 {
      color: ${grayMediumSphera};
      font-size: 1.4vw;
    }
    > p {
      color: ${neutralBlueGray};
    }
  }

  @media (max-width: 600px) {
    > h2 {
      font-size: 3vw;
    }
    > div {
      > h3 {
        font-size: 2.8vw;
      }
      > p {
        font-size: 2.8vw;
      }
    }
  }
`;

export const Success = styled.div`
  background-color: pink;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  margin: auto;
  padding: 10% 0;
  border-radius: 5px;
  background-color: ${whiteSphera};
  > figure {
    width: 150px;
    margin: 0 auto 5% auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  > h2 {
    color: ${brandBlack};
    font-size: 1.6vw;
    width: 100%;
    text-align: center;
    margin: 5% 0;
  }
  > p {
    font-size: 1.4vw;
    color: ${neutralBlueGray};
    margin-bottom: 3%;
    > a {
      color: ${greenSp};
      font-size: 1.4vw;
      font-weight: bold;
    }
  }
`;
